/**
 * Appends the product's own value to an option list when it isn't already in it, so a saved form number stays
 * selectable even when the BFF no longer lists it.
 * @param options The option list.
 * @param extra The value that must be selectable, if any.
 * @returns {string[]} `options`, plus `extra` when missing.
 */
export function withOption(options: readonly string[], extra?: string | null): readonly string[] {
  return extra && !options.includes(extra) ? [...options, extra] : options;
}
